import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

interface myData{
  success: boolean,
  message: string
}

interface registerResponse {
  success: boolean
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private loggedInStatus = false;

  constructor(private http: HttpClient) { }

  setLoggedIn(value: boolean){
    this.loggedInStatus = value;
  }

  get isLoggedIn(){
    return this.loggedInStatus;
  }

  getUserDetails(username, password){
    // post there details to api server return user info if correct

    return this.http.post<myData>('/api/login',  {
      username,
      password,
      withCredentials: true
    });
  }

  registerUser(username, password){
    return this.http.post<registerResponse>('/api/register', {
      username,
      password
    })
  }
}
